export default {
  singleLabel: "Pièce de rechange",
  storeNamespace: 'spare_part',
  authFeature: 'spare-part',
  listRouteName: "SparePartList",
  newRouteName: "SparePartNew",
  editRouteName: "SparePartEdit",
  detailRouteName: "SparePartDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'SparePartForm',
  csvExportFilenamePrefix: 'pieces-detachees',
  titleField: 'name',
  sortBy: 'name',
  showExtendedFilters: true,
  fields: [{
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'internal_code',
      label: "Code interne",
      type: 'text',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'description',
      label: "Description",
      type: 'textarea',
      inForm: true,
      required: false,
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'storage_environment_id',
      label: "Environnement de stockage",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'storage_environment',
      label: "Environnement de stockage",
      type: 'select',
      inForm: false,
      inList: false,
      inDetail: true,
      detailLink: 'StorageEnvironmentDetail',
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'brand',
      label: "Marque",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'brand_reference',
      label: "Référence marque",
      type: 'text',
      inForm: true,
      required: false,
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'stock_quantity',
      label: "Stock",
      type: 'number',
      inForm: true,
      required: true,
      inList: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'minimum_stock',
      label: "Stock minimum",
      type: 'number',
      inForm: true,
      required: true,
      inList: false,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
    },
    {
      name: 'supplier_id',
      label: "Fournisseur",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
      inCsvExport: false,
      inPdfExport: false,
    },
    {
      name: 'supplier',
      label: "Fournisseur",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      detailLink: 'CompanyDetail',
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'unit_purchase_price',
      label: "Prix d'achat à l'unité",
      type: 'number',
      step: 0.01,
      inForm: true,
      required: true,
      inList: false,
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '€' : null
    },
    {
      name: 'unit_purchase_price',
      label: "Prix d'achat à l'unité",
      type: 'number',
      inCsvExport: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) : null
    },
    {
      name: 'rebilling_percentage',
      label: "Pourcentage de refacturation",
      type: 'number',
      step: 0.01,
      inForm: true,
      required: true,
      inList: false,
      inDetail: true,
      inPdfExport: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) + '%' : null
    },
    {
      name: 'rebilling_percentage',
      label: "Pourcentage de refacturation",
      type: 'number',
      inCsvExport: true,
      formatter: (context, value) => value ? parseFloat(value).toFixed(2) : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: true,
      inPdfExport: false,
      formatter: (context, value) => value ? value ? context.$moment(value).format("dddd, DD MMMM YYYY") : null : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: true,
      inPdfExport: false,
      formatter: (context, value) => value ? value ? context.$moment(value).format("dddd, DD MMMM YYYY") : null : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/SparePart/config.js